import { Breakpoints } from 'elc-base-theme';
import { IResponsiveSettings, ICarouselSettings } from '../interfaces/IProdcat';

export const DEFAULT_IMAGE_CAROUSEL_SETTINGS = {
    vertical: false,
    verticalSwiping: false,
    arrows: true,
    dots: false,
    infinite: true,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: Breakpoints.desktop,
            settings: {
                dots: true
            }
        }
    ]
};

export const DEFAULT_THUMBNAILS_CAROUSEL_SETTINGS = {
    vertical: true,
    verticalSwiping: true,
    arrows: true,
    dots: false,
    infinite: true,
    swipeToSlide: true,
    focusOnSelect: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: Breakpoints.desktop,
            settings: {}
        }
    ]
};

export const VERTICAL_SWIPE_SETTINGS = {
    verticalSwiping: true,
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: Breakpoints.desktop,
            settings: {
                verticalSwiping: true,
                vertical: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

export const HORIZONTAL_SWIPE_SETTINGS = {
    verticalSwiping: false,
    vertical: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: Breakpoints.desktop,
            settings: {
                verticalSwiping: true,
                vertical: true,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

export const SCROLLSPY_OFFSET_TOP = 100;

export const getMobileCarouselSettings = (settings: ICarouselSettings) => {
    const responsiveMobileSettings = settings.responsive.find(
        (setting: IResponsiveSettings) => setting.breakpoint === Breakpoints.desktop
    );

    return responsiveMobileSettings && responsiveMobileSettings.settings;
};
